import './bootstrap';
import PageChecker from './modules/Page';
import { loader as componentLoader } from './components/components';
import { loader as directiveLoader } from './directives/directives';
import { loader as filterLoader } from './filters/filters';
import { loader as pluginLoader } from './plugins/plugins';
import Vue from 'vue';
import store from './store';
import VueMatchHeights from 'vue-match-heights';
import VueLazyload from 'vue-lazyload';
import 'paroller.js';
import AOS from 'aos';
import 'aos/dist/aos.css';

require('objectFitPolyfill/dist/objectFitPolyfill.basic.min.js');

Vue.use(VueLazyload, {
    preLoad: 1.3,
    listenEvents: [ 'scroll' ],
});

Vue.use(VueMatchHeights, {
    disabled: [768], // Optional: default viewports widths to disabled resizing on. Can be overridden per usage
});

/**
 * Setup global vars, bound to window
 */
window.Template = new PageChecker({ type: 'template' });
window.Page = new PageChecker({ type: 'page' });

window.bus = new Vue();
Vue.prototype.$bus = window.bus;

/**
 * Load Vue globals
 */
pluginLoader();
componentLoader();
directiveLoader();
filterLoader();

/**
 * Specific page loader
 * This allows us to lazy load page-specific functionality
 */
const LoadedPage = require('./pages/pages').default;

/**
 * Setup the Vue instance once
 * everything has loaded
 */

LoadedPage.then(() =>
    new Vue({
        el: '#app',

        store,

        mounted() {
            // Trigger the dom ready event so jQuery events can
            // bind on the newly rendered virtual dom
            this.$nextTick(() => $(document).trigger('domReady'));

            window.objectFitPolyfill();

            AOS.init({
                disable: 'mobile',
            });

            $('[data-paroller-factor]').paroller({
                type: 'foreground',
                direction: 'vertical',
            });
        },

        methods: {
            /**
             * Scrolls to element
             *
             * @param {HtmlElement} elem
             */
            scrollToElem(elem) {
                $('html, body').animate({
                    scrollTop: $(this.$refs[elem]).offset().top,
                }, 'slow');
            },
        },
    })
);

